import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  top: Number,
  bottom: Number,
  left: Number,
},
  setup(__props) {

const props = __props



const style = computed(() => {
  return {
    top: `${props.top}px`,
    bottom: `${props.bottom}px`,
    left: `${props.left}px`,
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle(_unref(style)),
    class: "tooltip-root"
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 4))
}
}

})